import { createSelector } from 'reselect';
import { isRunningContextCypress } from 'moet-test-utils/cypress/utils';
import {
  EXPERIMENTS,
  EXPERIMENTS_ENUM,
  EXPERIMENTS_TO_USER_PROPS_MAP,
  EXPERIMENTS_TO_USER_PROPS_MAP_ENUM,
} from '@/constants/experiments';

import { appState } from './utils';

const _experiments = createSelector(appState, ({ experiments }: GlobalState) => experiments);

export const getExperimentState = (
  experimentKey: EXPERIMENTS_ENUM,
): ((experiments: EXPERIMENTS_ENUM) => string) =>
  createSelector(_experiments, experiments => experiments[experimentKey]);

export const getExperimentsAsUserAttributes = createSelector(
  _experiments,
  (experiments): Partial<Record<EXPERIMENTS_TO_USER_PROPS_MAP_ENUM, EXPERIMENTS_ENUM>> => {
    return Object.keys(EXPERIMENTS_TO_USER_PROPS_MAP).reduce(
      (acc, curr) => ({
        ...acc,
        [EXPERIMENTS_TO_USER_PROPS_MAP[curr]]: experiments[curr] || 'off',
      }),
      {},
    );
  },
);

export const hasEmailConfirmationExperimentActive = createSelector(
  _experiments,
  experiments =>
    !isRunningContextCypress(window) &&
    experiments[EXPERIMENTS.EMAIL_VALIDATION] === 'email_confirmation',
);
